import React from 'react';
import { block } from '../../utils/cn';
import './DescDelimiter.css';
import { jsx as _jsx } from "react/jsx-runtime";
var b = block('search-desc-delimiter');
export function DescDelimiter() {
  return /*#__PURE__*/_jsx("span", {
    className: b(),
    children: "\u2022"
  });
}
// #sourceMappingURL=DescDelimiter.js.map